import React, { Component, PropTypes } from 'react';
import { Menu, Icon, Table, Button, Modal, Row, Col, Spin, Select, Radio, Carousel, Alert, Input, Form } from 'antd';
// import { DiscountTeacherModal } from 'components';

import { browserHistory, Link } from 'react-router';
import _ from 'lodash';
import cn from 'classnames';
import { formItemLayout } from 'constants/layout';
import TeacherHeader from './TeacherHeader';
import TeacherInfoTab from './TeacherInfoTab';
import TeacherCalendarTab from './TeacherCalendarTab';
import TeacherClassesTab from './TeacherClasses';
import TeacherRevenueTab from './TeacherRevenue';
import TeacherWithdrawalTab from './TeacherWithdrawal';
import TeacherVerificationTab from './TeacherVerification';

import { connect } from 'react-redux';
import { getTeacherById, getTeacherClassesById, getTeacherRevenue, getTransactionList, editTeacher } from 'data/teacher';
import { verifyUser, rejectUser } from 'data/user';

import classes from '../styles/teacher/TeacherInfo.module.scss';

const Confirm = Modal.confirm;

const TABS = [
  { label: 'Profile', value: 'profile' },
  { label: 'Calendar', value: 'calendar' },
  { label: 'Classes', value: 'classes' },
  { label: 'Revenue', value: 'revenue' },
  { label: 'Withdrawal', value: 'withdrawal' },
  { label: 'Verification', value: 'verification' },
];

class TeacherInfo extends Component {
  constructor(props) {
    super(props);
    this.onToggleMode = this.onToggleMode.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.onBan = this.onBan.bind(this);

    this.handleCancel = this.handleCancel.bind(this);
    this.showImageModal = this.showImageModal.bind(this);
    this.validateDropzoneInput = this.validateDropzoneInput.bind(this);
    this.onChangeFocusTab = this.onChangeFocusTab.bind(this);

    // props.getAutocompleteTeachers(props.classroom.owner.displayName);
    if (browserHistory) {
      this.backListener = browserHistory.listen((location) => {
        if (location.action === 'POP') {
          this.setState({ selectedTab: location.query.selectedTab ? location.query.selectedTab : 'profile' });
        }
      });
    }

    this.state = {
      collapseMobile: [],
      mode: 'editor',
      showModal: false,
      selectedTab: props.location.query.selectedTab ? props.location.query.selectedTab : 'profile',
    };
  }

  componentDidMount = async () => {
    const promises = [];
    // teacher: state.teacher.teacherDetail,
    // loading: state.teacher.teacherDetailWaiting,
    const id = this.props.params.id;
    this.setState({ loading: true });
    const [teacher, classes, revenue, transactions] = await Promise.all([getTeacherById(id), getTeacherClassesById(id), getTeacherRevenue(id), getTransactionList(id)]);

    this.setState({ loading: false, teacher, classes, revenue, transactions });
  };

  componentWillMount() {
    this.setState({
      showModal: false,
    });
  }

  componentWillUnmount() {
    this.backListener();
  }

  onDrop(acceptedFiles) {
    this.setState({
      file: acceptedFiles[0],
    });
    this.props.form.setFieldsValue({ file: acceptedFiles[0] });
    const reader = new window.FileReader();
    reader.readAsDataURL(acceptedFiles[0]);
    reader.onloadend = () => {
      const base64data = reader.result;
      const strBase64 = base64data.substr(base64data.indexOf(',') + 1);
      this.setState({ cover: strBase64 });
    };
  }

  onToggleMode() {
    const mode = this.state.mode === 'editor' ? 'preview' : 'editor';
    this.setState({
      mode,
    });
  }

  onEditorStateChange(editorState, key) {
    this.setState({
      [key]: editorState,
    });
  }

  onChangeFocusTab(tab) {
    this.setState({ selectedTab: tab.key });
    browserHistory.push(`${this.props.location.pathname}?selectedTab=${tab.key}`);
    // this.setState({
    //   selectedTab: tab.key,
    // });
  }

  onBan() {
    const teacher = this.state.teacher;
    editTeacher(teacher._id, { isBan: !teacher.isBan }).then(() => {
      this.reloadData();
    });
    // console.log(value);
    // this.setState({
    //   value,
    //   data: [],
    //   fetching: false,
    // });
  }

  showImageModal(url) {
    console.log(url);
    this.setState({
      showModal: true,
      imageUrl: url,
    });
  }

  handleVerify(id) {
    verifyUser(id).then(() => {
      browserHistory.push('/student');
    });
  }

  handleReject(id) {
    rejectUser(id).then(() => {
      browserHistory.push('/student');
    });
  }

  handleCancel() {
    this.setState({
      showModal: false,
      imageUrl: '',
    });
  }

  showBanConfirm(record, msg, content) {
    Confirm({
      title: 'Do you want to confirm?',
      // content: content || '',
      onOk: () => this.onBan(),
      // onCancel: this.onCancel,
    });
  }

  reloadData = async () => {
    const id = this.state.teacher._id;
    this.setState({ loading: true });
    const teacher = await getTeacherById(id);

    this.setState({ loading: false, teacher });
  };

  openDiscountModal() {
    this.setState({
      isOpenDiscountModal: true,
    });
  }
  closeDiscountModal() {
    this.setState({
      isOpenDiscountModal: false,
    });
  }

  validateDropzoneInput(rule, value, callback) {
    console.log(value, this.state.file);
    if (value || this.state.file) {
      callback();
    } else {
      callback('Image is missing!');
    }
  }

  articleStatuses = [
    { label: 'Active', value: 'active' },
    { label: 'Pending', value: 'pending' },
  ];

  renderModal() {
    const imageUrl = this.state.imageUrl;

    if (!this.state.showModal) {
      return <div />;
    }
    return (
      <Modal width="960px" className={classes.imageModal} title="" visible={this.state.showModal} onCancel={this.handleCancel} footer={null}>
        <img src={imageUrl} />
      </Modal>
    );
  }

  renderTabs() {
    return (
      <Menu onClick={this.onChangeFocusTab} selectedKeys={[this.state.selectedTab]} mode="horizontal">
        {TABS.map((tab) => (
          <Menu.Item key={tab.value} className={classes.menuItem}>
            <div>{tab.label}</div>
          </Menu.Item>
        ))}
      </Menu>
    );
  }

  render() {
    // console.log(this.state.files);
    if (!this.state.teacher) {
      return <div></div>;
    }
    const { loading, teacher } = this.state;
    const user = teacher.user;
    return (
      <div>
        {
          // <Spin tip="Loading" size="large" spinning={!!loading}>
          //   {user.verifyStatus === 'verified' && <Alert message="Verified user" type="success" showIcon description=" " />}
          //   {user.verifyStatus === 'rejected' && <Alert message="Rejected verify user" type="error" showIcon />}
          //   {this.renderEditorMode()}
          // </Spin>
        }
        <div className="page-header">
          {this.props.BreadCrumb}
          <TeacherHeader teacher={teacher} Tabs={this.renderTabs()} reload={this.reloadData} onOpenBanModal={() => this.showBanConfirm()} />
        </div>

        {this.state.selectedTab === 'profile' && <TeacherInfoTab teacher={teacher} getTeacherById={this.reloadData} loading={this.state.loading} />}
        {this.state.selectedTab === 'calendar' && <TeacherCalendarTab teacher={teacher} getTeacherById={this.reloadData} loading={this.state.loading} />}
        {this.state.selectedTab === 'classes' && <TeacherClassesTab teacher={teacher} loading={this.state.loading} classes={this.state.classes} getTeacherById={this.reloadData} />}
        {this.state.selectedTab === 'revenue' && <TeacherRevenueTab teacher={teacher} />}
        {this.state.selectedTab === 'withdrawal' && <TeacherWithdrawalTab teacher={teacher} loading={this.state.loading} reloadData={this.reloadData} />}
        {this.state.selectedTab === 'verification' && <TeacherVerificationTab teacher={teacher} loading={this.state.loading} reloadData={this.reloadData} />}
        {this.renderModal()}
      </div>
    );
  }
}
export default connect((state) => ({}), {})(Form.create()(TeacherInfo));
